export default __webpack_public_path__ + "static/media/MONUSCO_tailored_armed_group_strategies.712d795b.jpg";